<div class="wrapper">
  <div class="header">
    <div class="header-content">Error</div>
    <img class="close-image" [mat-dialog-close] src="../../../../assets/icons/cancel.svg" />
  </div>
  <div class="content">
    <div class="line">{{ message }}</div>
  </div>
  <div class="buttons">
    <div [mat-dialog-close]>
      <pdq-button label="Close" variant="primary"></pdq-button>
    </div>
  </div>
</div>
